import { render } from "./Footer.vue?vue&type=template&id=02bde028&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/styles/header/fonts.css?vue&type=style&index=0&id=02bde028&lang=css&scoped=true&external"
import "@/styles/home.css?vue&type=style&index=1&id=02bde028&lang=css&scoped=true&external"
import "./Footer.vue?vue&type=style&index=2&id=02bde028&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bde028"]])

export default __exports__